import {useState, useEffect} from 'react';
import {getExtraWorkEntries, getMonthExtraWorkEntries} from './endpoints';
import errorHandler from '../../../util/errorHandler';

export default function useExtraWorkEntriesState(customerId, month, t) {
    const [extraWorks, setExtraWorks] = useState([]);
    const [monthExtraWorks, setMonthExtraWorks] = useState([]);

    function loadExtraWorks(customerId) {
        getExtraWorkEntries(customerId)
            .then((response) => {
                setExtraWorks(response.data);
            })
            .catch((e) => errorHandler(e.response.data, true, t));
    }

    function loadMonthExtraWorks(customerId, month) {
        getMonthExtraWorkEntries(customerId, month)
            .then((response) => {
                setMonthExtraWorks(response.data);
            })
            .catch((e) => errorHandler(e.response.data, true, t));
    }

    useEffect(() => {
        if (month) loadMonthExtraWorks(customerId, month);
        else loadExtraWorks(customerId);
    }, [customerId, month]);

    return {
        extraWorks,
        monthExtraWorks,
        loading: extraWorks == [],
        loadingMonth: monthExtraWorks == [],
        reload: () => loadExtraWorks(customerId),
        reloadMonth: () => loadMonthExtraWorks(customerId, month),
    };
}
